<template>
  <naj-modal
    ref="caseJudgementModal"
    :width="1000"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closeJudgementModal"
  >
    <v-row>
      <div class="preview-holder">
        <div
          v-if="loading"
          class="loader-holder"
        >
          <naj-loader></naj-loader>
        </div>
        <template v-else>
          <div
            v-if="document"
            class="attachment-file-viewer pdf-file"
          >
            <div
              v-if="selectedJudgement.spid"
              class="pdf-container"
            >
              <div class="pdf-wrapper">
                <div class="pdf-holder">
                  <embed :src="fileUrl">
                </div>
              </div>
            </div>
            <p
              v-else
              class="document-text"
            >
              {{ document }}
            </p>
          </div>
        </template>
      </div>
    </v-row>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <span
        v-if="selectedJudgement.judgementCode"
        class="judgements-wrapper"
      >
        <naj-button
          outlined
          disabled
        >
          {{ local.judgementForms.judgementCode }} {{ selectedJudgement.judgementCode }}
        </naj-button>
      </span>
    </template>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'CaseJudgementModal',
  props: {
    selectedJudgement: { type: Object },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, false);
    },
  },
  mounted() {
  },
  methods: {
    ...mapCaseActions(['getTrustedSourceAttachment']),
    closeJudgementModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
    },
    getJudgementDocument() {
      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedJudgement.spid)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.caseJudgementModal.show();
        if (this.selectedJudgement.spid) {
          this.getJudgementDocument();
        } else {
          this.document = this.selectedJudgement.judgementText;
        }
      } else {
        this.$refs.caseJudgementModal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}

::v-deep .naj-modal-actions {
  justify-content: space-between;
  direction: ltr;
}

embed {
  width: 500px;
  height: 500px;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}
</style>